// extracted by mini-css-extract-plugin
export var gif = "_dc-0";